const timezones = Intl.supportedValuesOf('timeZone');

// Gets offset in minutes for easier sorting
export const getOffsetInMinutes = (timeZone) => {
    const date = new Date();
    const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone,
        timeZoneName: 'longOffset',
    });
    const parts = formatter.formatToParts(date);
    const offsetPart = parts.find(part => part.type === 'timeZoneName');

    if (offsetPart) {
        const offsetString = offsetPart.value;
        const offsetStringNoGmt = offsetString.split('GMT')[1];
        if (!offsetStringNoGmt) return 0;
        const [_, sign, hours, minutes] = offsetString.match(/([+-])(\d{2}):(\d{2})/);
        const totalMinutes = parseInt(hours, 10) * 60 + parseInt(minutes, 10);
        return sign === '-' ? -totalMinutes : totalMinutes;
    };
    return 0;
};

// Get timezone of the device and any timezone that shares a region with the device
export const getLocalTimezones = () => {
    const deviceTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const region = deviceTimezone.split('/')[0];
    const relatedTimezones = [...timezones].filter(tz => tz.startsWith(region));

    const timezonesWithOffset = relatedTimezones.map(tz => {
        const offsetMinutes = getOffsetInMinutes(tz);

        const offsetSign = offsetMinutes >= 0 ? '+' : '-';
        const offsetHours = Math.floor(Math.abs(offsetMinutes) / 60).toString().padStart(2, '0');
        const offsetMinutesPart = (Math.abs(offsetMinutes) % 60).toString().padStart(2, '0');
        const offsetString = `(UTC${offsetSign}${offsetHours}:${offsetMinutesPart})`;

        return {
            name: tz,
            offset: offsetString,
            offsetMinutes: offsetMinutes,
        };
    });

    timezonesWithOffset.sort((a, b) => {
        if (a.offsetMinutes !== b.offsetMinutes) {
            return a.offsetMinutes - b.offsetMinutes;
        }
        return a.name.localeCompare(b.name);
    });

    return timezonesWithOffset;
};